<template>
  <div id="account-welcome">
    <nav-bar-top icons-are-hidden />
    <div class="container has-nav-top-margin">
      <section class="section">
        <h4 class="title is-4">
          Welcome to SideSearch!
        </h4>
        <p>For security reasons, we've sent you a link to confirm your email and activate your account. Please check your email.</p>
        <br>
        <p>It may take up to a minute to receive our confirmation email, and in some cases it may mistakenly go to your spam folder.</p>
      </section>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';

export default {
  name: 'AccountWelcome',
  components: {
    NavBarTop
  }
};
</script>

<style scoped lang="scss">
</style>
